import { render, staticRenderFns } from "./MemberEdit.vue?vue&type=template&id=70d2f05a&"
import script from "./MemberEdit.vue?vue&type=script&lang=js&"
export * from "./MemberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports